import { NavList } from '@cpm-pr1618001/ng-design-lib';
import { Contacts } from 'src/app/store/user-management/state/user-management.state';
import { DASHBOARD_NAVIGATION_LIST } from '../../dashboard-constants';

export interface SearchedContact {
  contactUserId: number;
  emailId: string;
  isContactAdded: boolean;
  firstName: string;
  lastName: string;
  status: RequestStatus | null;
  uId: number;
  requestedByUserId?: number;
  isRequester?: boolean;
}

export enum RequestStatus {
  REQUEST_APPROVED = 'REQUEST_APPROVED',
  REQUEST_ACCEPTED = 'REQUEST_ACCEPTED',
  REQUEST_DENIED = 'REQUEST_DENIED',
  REQUEST_RECEIVED = 'REQUEST_RECEIVED',
  REQUEST_SENT = 'REQUEST_SENT',
}
// NULLABLE is used to indicate that the contact is not yet added - SENDER
// REQUEST_APPROVED is used to indicate that the contact is ACCEPTED FROM THE OTHER USER - RECEIVER
// REQUEST_DENIED is used to indicate that the contact is DENIED FROM THE OTHER USER - RECEIVER
export interface ContactPayload {
  userId: string;
  status: RequestStatus | null;
  contact: {
    id?: number;
    email?: string;
  };
}

export interface InviteContactPayload {
  userId: number;
  contact: Partial<Pick<Contacts, 'emailId' | 'contactUserId'>>;
  status: RequestStatus | null;
}

export interface SavingsBalance {
  totalSavings: number;
}

export interface StocksBalance {
  totalInvestedAmount: number;
}

export interface CreditCardsBalance {
  totalCardsLimit: number;
  availableBalance: number;
}

export interface LoansBalance {
  totalLoansAmount: number;
  remainingBalance: number;
}

export interface ExpensesBalance {
  totalYouOwe: number;
  totalYouLent: number;
}

export interface BalancesOverview {
  savings: SavingsBalance;
  stocks: StocksBalance;
  creditCards: CreditCardsBalance;
  loans: LoansBalance;
  expenses: ExpensesBalance;
}

export interface BalancesOverviewResponse {
  userId: number;
  balances: BalancesOverview;
}

export interface RecentTransactionActivity {
  activityId: number;
  eventType: string;
  eventAt: string;
  expenseId: number;
  transactionId: number | null;
  expenseName: string | null;
  transactionDate: string | null;
  oldPaidByUserId?: number;
  newPaidByUserId?: number;
  oldExpenseName?: string;
  newExpenseName?: string;
  oldSharingType?: string;
  newSharingType?: string;
  oldTotalAmount?: number;
  newTotalAmount?: number;
  oldCreatedByUserId?: number;
  newCreatedByUserId?: number;
  oldUpdatedByUserId?: number;
  newUpdatedByUserId?: number;
  oldTransactionDate?: string;
  newTransactionDate?: string;
  oldBorrowerUserId?: number;
  newBorrowerUserId?: number;
  oldBorrowedAmount?: number;
  newBorrowedAmount?: number;
  oldPaymentStatus?: string;
  newPaymentStatus?: string;
  oldTransactionStatus?: string;
  newTransactionStatus?: string;
  actorUserId: number | null;
  actorName: string | null;
  paidByUserId: number | null;
  paidByName: string | null;
  borrowerUserId: number | null;
  borrowerName: string | null;
}

export interface RecentTransactionsResponse {
  userId: number;
  selectedYear: number;
  totalCount: number;
  activities: RecentTransactionActivity[];
}

export interface DashboardState {
  searchedContacts: SearchedContact[];
  searchedContact: string;
  isAddContactProcessing: boolean;
  isInviteContactSending: boolean;
  dashBoardNavigaionList: NavList[];
  balancesOverview: BalancesOverviewResponse | null;
  recentTransactionActivities: RecentTransactionActivity[];
  isRecentTransactionsLoading: boolean;
  recentTransactionsError: boolean;
}

export const initialDashboardState: DashboardState = {
  searchedContacts: null,
  searchedContact: null,
  isAddContactProcessing: false,
  isInviteContactSending: false,
  dashBoardNavigaionList: DASHBOARD_NAVIGATION_LIST,
  balancesOverview: null,
  recentTransactionActivities: [],
  isRecentTransactionsLoading: false,
  recentTransactionsError: false,
};
